'use strict';

var curry = require('./curry.js');
require('./chunk-d7703e54.js');
require('./variadic.js');
require('./chunk-e6d921c6.js');
require('./head.js');
require('./tail.js');
require('./copy.js');
require('./_get.js');
require('./chunk-fac2c876.js');
require('./_set.js');
var _pick = require('./_pick.js');

/**
 * Picks properties of an object.
 *
 * @function
 * @param {Array} ks The list of keys.
 * @param {Object} o The object.
 * @returns {Object} A copy of the object `o` *with* the properties in the list
 * of `ks`.
 * @example
 *
 * import { pick } from 'fkit'
 * const person = { name: 'Jane', age: 20, city: 'Melbourne' }
 * pick(['name', 'age'], person) // { name: 'Jane', age: 20 }
 */

var pick = curry(_pick);

module.exports = pick;
